<template>
    <div class="order-container">
        <div class="write-off-title">
            当前客户存在多个待提货订单，请选择订单核销提货
        </div>
        <div class="order-list">
            <van-checkbox-group v-model="orderresult" ref="orderlistgroup">
                <van-checkbox checked-color="#DCBB89" v-for="(item, index) in orderlist" :key="index" :name="item.id">
                    <div class="order-info">
                        <div class="order-top">
                            <div class="order-name">{{ item.name }}</div>
                            <div class="order-status">{{ item.status }}</div>
                        </div>
                        <div class="order-bottom">
                            <div class="order-title">
                                手  机  号：
                                <span class="title-content">{{ item.mobile }}</span>
                            </div>
                            <div class="order-title">
                                下单时间：
                                <span class="title-content">{{ item.time }}</span>
                            </div>
                            <div class="order-list-title">
                                <div class="title-content-list">
                                    商品列表：
                                </div>
                                <div class="content-list">
                                    <div v-for="(shopitem, shopindex) in item.shplist" :key="shopindex">
                                        {{ shopitem.name }} * {{ shopitem.number }}
                                    </div>
                                </div>

                            </div>
                            <div class="order-title">
                                订单金额：
                                <span class="title-content">{{ item.price }}元</span>
                            </div>
                        </div>
                    </div>
                </van-checkbox>
            </van-checkbox-group>
        </div>
    </div>
    <div class="border-bottom">
        <div class="border-center">
            <van-checkbox class="full-select" v-model="isSelected" checked-color="#DCBB89"
                @change="selectOrder">全选</van-checkbox>
        </div>
        <div class="border-cancel" @click="blankCancel">取消</div>
        <div class="border-go" @click="goWriteOff">前往核销</div>
    </div>
</template>
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'

const router = useRouter()

const orderlist = ref([
    {
        id: 1,
        name: '客户A',
        status: '待提货',
        mobile: '13800000000',
        time: '2023-08-01 10:00:00',
        shplist: [
            {
                id: 1,
                name: '商品A',
                number: 2,
                price: 50.00
            },
            {
                id: 2,
                name: '商品B',
                number: 1,
                price: 30.00
            }
        ],
        price: 100.00
    },
    {
        id: 2,
        name: '客户B',
        status: '待提货',
        mobile: '13800000000',
        time: '2023-08-01 10:00:00',
        shplist: [
            {
                id: 1,
                name: '商品A',
                number: 2,
                price: 50.00
            },
            {
                id: 2,
                name: '商品B',
                number: 1,
                price: 30.00
            }
        ],
        price: 100.00
    },
])

const isSelected = ref(false)
const orderresult = ref([]);
const orderlistgroup = ref(null);
// 全选/取消全选
const selectOrder = () => {
    if (isSelected.value) {
        orderlistgroup.value.toggleAll(true);
    } else {
        orderlistgroup.value.toggleAll(false);
    }
    orderresult.value = isSelected.value ? orderlist.value.map(item => item.id) : [];
}
//取消返回上一页
const blankCancel = () => {
    router.back()
}
// 前往核销
const goWriteOff = () => {
    if (orderresult.value.length === 0) {
        showToast('请选择订单')
        return
    }
    console.log(orderresult.value);
    router.push({
        path: '/orderwrite',
        query: {
            orderid: orderresult.value.join(',')
        }
    })
}
</script>
<style lang="less" scoped>
.order-container {
    height: 100vh;
    margin-bottom: 70px;

    .write-off-title {
        font-size: 14px;
        font-weight: 500;
        color: #3C211F;
        font-style: normal;
        text-transform: none;
        margin-bottom: 5px;
        font-family: 'PingFang SC-Medium';
        padding: 17px 13px;
        text-align: center;
        background-color: rgba(220, 187, 137, 0.08);
    }

    .order-list {
        padding: 13px 17px;

        .order-info {
            background-color: #fff;
            padding: 15px  13px 6px 13px;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #DCBB89;
            width: 310px;

            .order-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #F5F5F5;
                padding-bottom: 13px;

                .order-name {
                    font-size: 17px;
                    font-weight: 500;
                    color: #333;
                    margin-bottom: 5px;
                    font-family: 'PingFang SC-Medium';
                }

                .order-status {
                    font-size: 15px;
                    font-weight: 400;
                    color: #FF7123;
                    font-family: 'PingFang SC-Medium';
                }
            }

            .order-bottom {
                padding-top: 13px;

                .order-title {
                    font-size: 15px;
                    font-weight: 500;
                    color: #666;
                    font-family: 'PingFang SC-Medium';
                    margin-bottom: 8px;

                    .title-content {
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;
                        font-family: 'PingFang SC-Medium';
                    }
                }
                .order-list-title {
                    margin-bottom: 8px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    .title-content-list {
                        font-size: 15px;
                        font-weight: 500;
                        color: #666;
                        font-family: 'PingFang SC-Medium';
                    }
                    .content-list{
                        font-size: 15px;
                        font-weight: 500;
                        color: #333;
                        font-family: 'PingFang SC-Medium';
                    }
                }
            }
        }
    }
}

.border-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 17px 20px 17px;
    border-bottom: 1px solid #E5E5E5;
    background-color: #FFFFFF;

    .border-center {
        display: flex;
        align-items: center;

        .full-select {
            font-size: 15px;
            color: #333;
            font-family: 'PingFang SC-Medium';
            font-weight: 500;
            margin-left: 4px;
        }
    }

    .border-cancel {
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #eee;
        font-size: 15px;
        color: #666;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        margin-left: 44px;
    }

    .border-go {
        font-size: 15px;
        color: #fff;
        width: 105px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #DCBB89;
        font-size: 15px;
        font-family: 'PingFang SC-Medium';
        font-weight: 400;
        line-height: 36px;
        text-align: center;
        background-color: #DCBB89;
    }
}
</style>